import { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import Constante from "../../util/Constante";
import Util from "../../util/Util";
import HeaderSistema from "./components/HeaderSistema";
import DocumentoItem from "lirida-back-service/Servicos/Documento/DocumentoItem";
import DocumentoService from 'lirida-back-service/Servicos/Documento/DocumentoService';
import { TabPanel, TabView } from "primereact/tabview";

export default class DocumentoDetalhe extends Component {

    util = new Util()
    constante = new Constante()
    documentoService = new DocumentoService(this.constante.token, this.constante.url_base)

    state = {
        documentoItem: new DocumentoItem(),
        listaRelacionamentoDocumentoItem: [],
    }

    componentDidMount() {
        this.iniciar()
    }

    async iniciar() {
        let pessoaUsuario = this.util.buscarLocalStorage("PESSOA_USUARIO");
        let parametro = await this.util.buscarParametros();
        let seqDocumentoItem = parametro?.id;
        let retorno = await this.documentoService.buscarItem(this.constante.seqUsuario, seqDocumentoItem);
        let documentoItem = retorno.objeto;
        console.log(documentoItem);

        retorno = await this.documentoService.listarRelacionamentoItem(documentoItem);
        let listaRelacionamentoDocumentoItem = retorno?.objeto;

        this.setState({
            pessoaUsuario: pessoaUsuario,
            documentoItem: documentoItem,
            listaRelacionamentoDocumentoItem: listaRelacionamentoDocumentoItem,
        })
    }

    render() {
        return (
            <div>
                <HeaderSistema />
                <main style={{ width: "98%", margin: "20px auto" }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 20,
                            border: "1px solid lightgray",
                            padding: 20,
                            borderRadius: 3,
                        }}
                    >
                        <Button
                            style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
                            onClick={() => window.location.href = '/sistema/documentos'}
                            icon='pi pi-arrow-left'
                        />
                        <div>
                            <h1 style={{ fontSize: 22, margin: 0 }}>Documento detalhe</h1>
                            <h2 style={{ fontSize: 20, color: 'gray', margin: 0 }}>Documento detalhe</h2>
                        </div>
                    </div><br />

                    <form
                        onSubmit={e => {
                            e.preventDefault();
                        }}>

                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                            <i style={{ color: this.constante.corPrincipal, fontSize: '1rem', padding: 8, borderRadius: 360, border: `1px solid ${this.constante.corPrincipal}` }} className="pi pi-file" />
                            <h3>Informações do documento</h3>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20, gap: 60 }}>

                            {/* INFORMAÇÕE DO DOCUMENTO */}
                            <div style={{ width: '100%', display: "grid", gridTemplateColumns: " 1fr 1fr 1fr", gap: 20, }}>
                                <div >
                                    <label>Status</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem?._tipoDocumentoProcessoNome}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Item nome</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._itemNome}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Valor</label><br />
                                    <InputText
                                        disabled
                                        value={'R$' + this.util.formatarValor(this.state.documentoItem.precoTabelaMaximo)}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Data Cadastro</label><br />
                                    <Calendar
                                        disabled
                                        dateFormat="dd/mm/yy"
                                        value={this.util.formatarDataCalendar(this.state.documentoItem.dataCadastro)}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Data programada</label><br />
                                    <Calendar
                                        disabled
                                        value={this.util.formatarDataCalendar(this.state.documentoItem.dataProgramada)}
                                        dateFormat="dd/mm/yy"
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>
                            </div>
                            {/* FIM DADOS PESSOAIS */}
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 20 }}>
                            <i style={{ color: this.constante.corPrincipal, fontSize: '1rem', padding: 8, borderRadius: 360, border: `1px solid ${this.constante.corPrincipal}` }} className="pi pi-id-card" />
                            <h3>Informações do solicitante</h3>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20, gap: 60 }}>

                            {/* INFORMAÇÕE DO SOLICITANTE */}
                            <div style={{ width: '100%', display: "grid", gridTemplateColumns: " 1fr 1fr 1fr", gap: 20, }}>
                                <div >
                                    <label>Nome</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem?._pessoaNome}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>E-mail</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._pessoaEmail}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Telefone</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._pessoaTelefone}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>
                            </div>
                            {/* FIM DADOS PESSOAIS */}
                        </div>

                        {/* ENDEREÇO */}
                        <div><br />
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                <i style={{ color: this.constante.corPrincipal, fontSize: '1rem', padding: 8, borderRadius: 360, border: `1px solid ${this.constante.corPrincipal}` }} className="pi pi-home" />
                                <h3>Local de Serviço</h3>
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 20, border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20 }}>
                                <div >
                                    <label>Nome condominio</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem.tags5}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Bloco /  sala</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem.tags2}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>

                                <div >
                                    <label>Logradouro</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._endLogradouro}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>


                                <div >
                                    <label>Número</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._endNumero}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>


                                <div >
                                    <label>Bairro</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._endBairro}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>


                                <div >
                                    <label>Cidade</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._endCidade}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>


                                <div >
                                    <label>UF</label><br />
                                    <InputText
                                        disabled
                                        value={this.state.documentoItem._endUF}
                                        style={{ width: '100%', height: 40 }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* FIM ENDEREÇO */}
                    </form>

                    <div style={{ border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20 }}>
                        <TabView style={{ marginTop: 10 }}>
                            <TabPanel header="Relacionamentos" >
                                <DataTable
                                    showGridlines
                                    removableSort
                                    paginator
                                    responsiveLayout="scroll"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                    rows={5}
                                    rowsPerPageOptions={[5, 10, 20]}
                                    style={{ width: "100%", marginTop: 30 }}
                                    value={this.state.listaRelacionamentoDocumentoItem}
                                >
                                    <Column
                                        header="Nome"
                                        field="_pessoaRelacionadaNome"
                                        sortable />

                                    <Column
                                        header="Tipo Relacionamento"
                                        field="_tipoRelacionamentoNome"
                                        sortable />

                                    <Column
                                        header="Data cadatastro"
                                        field="dataCadastro"
                                        sortable
                                        body={pItem => this.util.formatarData(pItem.dataCadastro)}
                                    />
                                </DataTable>
                            </TabPanel>
                        </TabView>
                    </div>
                </main>
            </div >
        )
    }
}